const actions = {
  SET_SUCURSAL: 'SET_SUCURSAL',
  SET_SUCURSALES_LIST: 'SET_SUCURSALES_LIST',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',

  setSucursal: (sucursal) => ({
    type: actions.SET_SUCURSAL,
    payload: sucursal,
  }),

  setSucursalesList: (list) => ({
    type: actions.SET_SUCURSALES_LIST,
    payload: list,
  }),

  setLoading: (loading) => ({
    type: actions.SET_LOADING,
    payload: loading,
  }),

  setError: (error) => ({
    type: actions.SET_ERROR,
    payload: error,
  }),
};

export default actions;
